<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
    <section class="menu-item">
        <HZLink :to="menuObject" class="menu-item-detail">
        <span v-if="menuObject.type !== 'default'" class="list-icon">
          <span v-if="menuObject.type === 'email'"><i class="fa-solid fa-envelope"></i></span>
          <span v-else-if="menuObject.type === 'phone'"><i class="fa-solid fa-phone"></i></span>
          <span v-else-if="menuObject.type === 'linkedin'"><i class="fa-brands fa-linkedin-in"></i></span>
          <span v-else-if="menuObject.type === 'instagram'"><i class="fa-brands fa-instagram"></i></span>
          <span v-else-if="menuObject.type === 'facebook'"><i class="fa-brands fa-facebook-f"></i></span>
        </span>
            <span v-else class="menu-icon-container">
            <span class="menu-item-ico-blue"><img height="22" src="@/assets/img/menu-symbol-blue.webp"
                                                  width="22"/></span>
            <span class="menu-item-ico-white"><img height="22" src="@/assets/img/menu-symbol-white.webp"
                                                   width="22"/></span>
          </span>
            <span class="menu-text">{{ menuObject.text }}</span>
        </HZLink>

    </section>
</template>

<script>
import HZLink from "@/support/HZLink.vue";

export default {
    name: "MenuItem",
    components: {HZLink},
    props: {
        menuObject: {
            type: Object,
            default: () => {
                return {name: "Home", text: "Home", hash: ""}
            }
        }
    },


}
</script>

<style scoped>
.menu-item, .menu-text {
    color: var(--e-global-color-text);
    cursor: pointer;
}

.menu-item-detail {
    display: flex;
    align-items: center;
}

.menu-item:hover .menu-text {
    color: var(--e-global-color-secondary);
}

.list-icon {
    margin-right: 20px;
    color: var(--e-global-color-secondary);
    width: 14px;
}

.menu-item:hover .list-icon {
    transition-duration: .3s;
    transform: scale(1.2);
    transform-origin: left;
}

.menu-icon-container {

}

.menu-item-ico-blue, .menu-item-ico-white {
    position: relative;
    transition: all .2s ease-in;
}


.menu-item-ico-white {
    left: -14px;
}

.menu-item-ico-blue {
    left: 0;
    z-index: 0;
}

.menu-item:hover .menu-item-ico-blue {
    left: 8px;
    z-index: 100;
}

</style>